export const ROUTES = {
  DASHBOARD: '/',
  ONBOARDING: '/onboarding',

  PROPERTIES: '/properties',
  PROPERTY: '/properties/:id',
  EDIT_PROPERTY: '/properties/:id/edit',
  NEW_PROPERTY: '/properties/new',

  COMMERCIAL_PROPERTIES: '/properties/commercial',

  RESIDENTIAL_PROPERTIES: '/properties/residential',
  RESIDENTIAL_PROPERTY: '/properties/residential/:id',
  EDIT_RESIDENTIAL_PROPERTY: '/properties/residential/:id/edit',
  NEW_RESIDENTIAL_PROPERTY: '/properties/residential/new',

  LEASES: '/leases',
  LEASE: '/leases/:id',
  EDIT_LEASE: '/leases/:id/edit',
  NEW_LEASE: '/leases/new',
  LEASE_INVITE: '/lease-invite/:code',
  LEASE_CREATED: '/leases/:id/success',

  INVOICES: '/invoices',
  INVOICE: '/invoices/:id',
  EDIT_INVOICE: '/invoices/:id/edit',
  NEW_INVOICE: '/invoices/new',

  REMINDERS: '/reminders',
  REMINDERS_SENT: '/reminders/events',
  REMINDER: '/reminders/:id',
  NEW_REMINDER: '/reminders/new',
  EDIT_REMINDER: '/reminders/:id/edit',

  TENANTS: '/tenants',
  TENANT: '/tenants/:id',
  EDIT_TENANT: '/tenants/:id/edit',
  NEW_TENANT: '/tenants/new',

  PAYMENTS_RECORDS: '/payments-records',
  PAYMENT_RECORD: '/payments-records/:id',
  NEW_PAYMENT_RECORD: '/payments-records/new',
  EDIT_PAYMENT_RECORD: '/payments-records/:id/edit',

  USER: '/user',
  SUPPORT: '/support',

  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_USER: '/admin/users/:id',
  ADMIN_OUTREACH: '/admin/outreach',
  ADMIN_OUTREACH_ITEM: '/admin/outreach/:id',
  ADMIN_COMM_EVENTS: '/admin/comm-events',
  ADMIN_COMM_EVENT: '/admin/comm-events/:id',
  ADMIN_INVOICES: '/admin/invoices',
  ADMIN_PAYMENTS: '/admin/payments',
  ADMIN_LEASES: '/admin/leases',
  ADMIN_PROPERTIES: '/admin/properties',
  ADMIN_PARTNER_APPLICATIONS: '/admin/partner-applications',

  LOGIN: '/login',
  SIGN_UP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  EMAIL_CONFIRMATION: '/email-verification-success',
  OAUTH_SUCCESS: '/oauth-success',
  VERIFY_EMAIL: '/verify-email',

  TENANT_SCOPE: '/tenant',
  TENANT_LOGIN: '/tenant/login',
  // TENANT_SIGN_UP: '/tenant/signup',
  TENANT_CONNECT: '/tenant/connect',
  TENANT_PROPERTIES: '/tenant/properties',
  TENANT_PROPERTY: '/tenant/properties/:id',
  TENANT_REMINDERS: '/tenant/reminders',
  TENANT_SUPPORT: '/tenant/support',

  TENANT_LEASES: '/tenant/leases',
  TENANT_LEASE: '/tenant/leases/:id',

  TENANT_INVOICES: '/tenant/invoices',
  TENANT_INVOICE: '/tenant/invoices/:id',

  TENANT_PAYMENTS: '/tenant/payments-records',
  TENANT_PAYMENT: '/tenant/payments-records/:id',
  TENANT_NEW_PAYMENT: '/tenant/payments-records/new',
};
